module.exports = __webpack_public_path__ + "img/klaus-a1.8bd13057.svg";